import { Languages } from "lucide-react";
import { LANGS, getLang, setLang, t } from "@/lib/i18n";

export const LanguagePicker = ({ compact = false }) => (
  <label className={`relative inline-flex ${compact ? "h-11 min-w-[2.75rem]" : "h-9 min-w-[7.5rem]"} cursor-pointer items-center gap-1.5 rounded-lg border border-border px-2 text-sm font-semibold text-muted-foreground transition-colors hover:border-brand-primary hover:text-foreground`} title={t("Language")}>
    <Languages className="h-4 w-4 shrink-0" />
    <span aria-hidden="true">{compact ? getLang().toUpperCase() : LANGS.find(([k]) => k === getLang())[1]}</span>
    <select data-testid="language-select" aria-label={t("Language")} value={getLang()} onChange={(e) => setLang(e.target.value)} className="absolute inset-0 h-full w-full cursor-pointer opacity-0">
      {LANGS.map(([k, label]) => <option key={k} value={k}>{compact ? k.toUpperCase() : label}</option>)}
    </select>
  </label>
);

export const MachineTranslationBanner = () => (getLang() === "en" ? null : (
  <div data-testid="mt-banner" className="mb-6 rounded-lg border border-brand-action/40 bg-brand-action/10 px-4 py-2.5 text-sm font-medium">{t("mt-banner")}</div>
));

export const MachineTranslationNote = ({ bar = false }) => (getLang() === "en" ? null : (
  <div data-testid={bar ? "mt-bar" : "mt-note"} className={bar ? "border-b border-brand-action/30 bg-brand-action/10 px-4 py-1.5 text-center text-xs font-medium" : "px-1 text-[11px] leading-snug text-muted-foreground"}>{t("mt-short")}</div>
));
